import { RootState } from "@/redux/store";

export const payInvoiceSelector = (state: RootState) => state.payInvoice.payInvoice;
export const payByCreditCardSelector = (state: RootState) => state.payInvoice.payByCreditCard;
